import React from 'react';
import styles from './ParticleBackground.module.scss';

const ParticleBackground: React.FC = () => {
  const particles = Array.from({ length: 50 }, (_, i) => i);

  return (
    <div className={styles['particle-background']}>
      {particles.map((i) => (
        <div key={i} className={styles.particle} />
      ))}
    </div>
  );
};

export default ParticleBackground;
